import { createSelector } from 'reselect';

import * as entitySelectors from 'store/entities/selectors';

export const selectAllSkillCategoriesForSelection = createSelector(
  entitySelectors.selectSkillCategoriesEntities,
  skillCategoriesEntities =>
    Object.keys(skillCategoriesEntities).map(
      skillCategoryId => skillCategoriesEntities[skillCategoryId]
    )
);
